// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Services
import VehicleNumberBookingService from '@services/vehicle/numberbooking'

export const getAllVehicleNumberBookings = createAsyncThunk('vehicleNumberBooking/getAllVehicleNumberBookings', async (params, { rejectWithValue }) => {
  try {
    const response = await VehicleNumberBookingService.getAllVehicleNumberBookings(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})


export const getVehicleNumberBooking = createAsyncThunk('vehicleNumberBooking/getVehicleNumberBooking', async (id) => {
  const response = await VehicleNumberBookingService.getVehicleNumberBookingById(id)
  return response
})

export const vehicleNumberBookingSlice = createSlice({
  name: 'vehicleNumberBooking',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedVehicleNumberBooking: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllVehicleNumberBookings.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllVehicleNumberBookings.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.total
        state.allData = action.payload.data
        state.loading = false
      })
      .addCase(getAllVehicleNumberBookings.rejected, (state) => {
        state.loading = false
      })
      .addCase(getVehicleNumberBooking.pending, (state) => {
        state.loading = true
      })
      .addCase(getVehicleNumberBooking.fulfilled, (state, action) => {
        state.selectedVehicleNumberBooking = action.payload
        state.loading = false
      })
      .addCase(getVehicleNumberBooking.rejected, (state) => {
        state.loading = false
      })
  }
})

export default vehicleNumberBookingSlice.reducer
